import {Route} from '@angular/router';
import {LoginCallbackComponent,} from '@dabnet-kamu/libs/auth/components/login-callback/login-callback.component';
import {LogoutCallbackComponent,} from '@dabnet-kamu/libs/auth/components/logout-callback/logout-callback.component';
import {SilentCallbackComponent,} from '@dabnet-kamu/libs/auth/components/silent-callback/silent-callback.component';
import {AuthGuard} from '@dabnet-kamu/libs/auth/auth.guard';
import {KontrollerComponent,} from '@dabnet-kamu/libs/teb/gecici/kontroller/kontroller.component';
import {LookupComponent,} from '@dabnet-kamu/libs/teb/gecici/lookup/lookup.component';
import {ExampleComponent} from '@dabnet-kamu/libs/ui/example/example.component';
import {HesabimComponent} from '@dabnet-kamu/libs/ui/shared/components/hesabim/hesabim.component';
import {MainComponent} from '@dabnet-kamu/libs/ui/shared/layouts/main/main.component';
import {NoRoleFoundComponent} from '@dabnet-kamu/libs/ui/shared/components/no-role-found/no-role-found.component';
import { OpeningScreenComponent,} from '@dabnet-kamu/libs/ui/shared/components/opening-screen/opening-screen.component';
import { SayfaBulunamadiComponent,} from '@dabnet-kamu/libs/ui/shared/components/sayfa-bulunamadi/sayfa-bulunamadi.component';
import { TestPrintComponent } from '@dabnet-kamu/libs/ui';


export const appRoutes: Route[] = [
  {path: '', pathMatch: 'full', redirectTo: 'main/dabnet'},
  {path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'main/dabnet'},

  {
    path: 'callback',
    component: LoginCallbackComponent,
  },

  {
    path: 'logout',
    component: LogoutCallbackComponent,
  },

  {
    path: 'refreshtoken',
    component: SilentCallbackComponent,
  },
  {
    path: 'example',
    component: ExampleComponent
  },
  {
    path: 'test-printer',
    component: TestPrintComponent
  },
  {
    
    path: 'no-auth',
    component: NoRoleFoundComponent
  },
  // Sistem durum sayfası: AuthGuard dışında; kendi yetkisi var (DaBIdentity rolü veya durum anahtarı),
  // DaBIdentity çökmüşken de açılabilsin diye.
  {
    path: 'status',
    loadComponent: () =>
      import('@dabnet-kamu/ys/components/sistem-durum/sistem-durum.component').then(m => m.SistemDurumComponent),
  },
  {path: 'heartbeat', pathMatch: 'full', redirectTo: 'status'},
  // Yönetim sayfaları (/manage/*): Durum izleme içindir, değiştiren işlemler burada. Yetkiyi SUNUCU denetler
  // (DaBIdentity token + Durum:IzinliRoller rolü; durum anahtarı kabul edilmez).
  // 13.10.2026: AuthGuard geçici olarak kaldırılmıştı (doğrudan adresle açılışta ana sayfaya düşülüyordu); AuthGuard
  // kullanıcıyı depodan bekleyip dönüş adresini saklayacak şekilde düzeltildi (auth.guard.ts / login-callback), geri eklendi.
  // {
  //   path: 'manage/db',
  //   loadComponent: () =>
  //     import('@dabnet-kamu/ys/components/manage-db/manage-db.component').then(m => m.ManageDbComponent),
  // },
  {
    path: 'manage/db',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('@dabnet-kamu/ys/components/manage-db/manage-db.component').then(m => m.ManageDbComponent),
  },
  // 14.10.2026: servislerin appsettings.json + ortak ayar dosyası (../dabconfig/app.ortak.config); yetki /manage/db ile aynı
  {
    path: 'manage/config',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('@dabnet-kamu/ys/components/manage-config/manage-config.component').then(m => m.ManageConfigComponent),
  },
  {
    path: 'main',
    canActivate: [AuthGuard],
    component: MainComponent,
    children: [

      {
        path: 'dabnet',
        loadComponent: () => import('../route-tab-lazy/route-tab-lazy.component')
          .then(m => m.RouteTabLazyComponent)
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('@dabnet-kamu/raporlar/dashboard-page/dashboard-page.component').then(m => m.DashboardPageComponent),
      },
      {
        path: 'lookups',
        component: LookupComponent,
      },
      {
        path: 'controls',
        component: KontrollerComponent,
      },
      {
        path: 'schedular',
        loadComponent: () =>
          import('@dabnet-kamu/libs/ui/shared/components/takvim/takvim.component').then(m => m.TakvimComponent),
      },

      {
        path: 'task',
        loadComponent: () =>
          import('@dabnet-kamu/libs/ui/shared/planing/task/task.component').then(m => m.TaskComponent),
      },
      {
        path: 'task/detail',
        loadComponent: () =>
          import('@dabnet-kamu/libs/ui/shared/planing/task/planning-task-details/planning-task-details.component').then(m => m.PlanningTaskDetailsComponent),
      },
      {
        path: 'hesabim',
        component: HesabimComponent,
      },
      {
        path: 'personel',
        component: OpeningScreenComponent
      },
      {path: '**', component: SayfaBulunamadiComponent},
    ],
  },
  {path: '**', component: SayfaBulunamadiComponent},
];
